import * as React from 'react';
import { parseEditorContent, getDefaultExtensions, getExtensionsForPreset } from './presets';
import { useEditor } from '@tiptap/react';
import { setEditor } from './editor_cache';
import type { Editor } from '@tiptap/react';
import type { EditorPreset } from './presets';
import type { CharacterCountConfig } from './extensions/custom_character_count';

interface IEditorContext {
   editor: Editor;
}

const editorContextDefaults: IEditorContext = {
   editor: null,
};

const EditorContext = React.createContext<IEditorContext>(editorContextDefaults);

export const useEditorContext = () => React.useContext(EditorContext);

export const withEditorContext = (Component: any) => {
   return function withEditorContextComponent(props: {
      editorid: string;
      text?: string;
      preset: EditorPreset;
      characterCountConfig?: CharacterCountConfig;
      submitHandler?: () => void;
      handleModified?: (modified: boolean) => void;
   }) {
      const { editorid, text = '', preset } = props;

      const extensions = [...getExtensionsForPreset(preset), ...getDefaultExtensions(props)];

      const editor = useEditor({
         extensions,
         content: parseEditorContent(text),
      });

      const editorContext = {
         editor,
      };

      React.useEffect(() => {
         setEditor(editorid, editor);
      }, [editor]);

      return (
         <EditorContext.Provider value={editorContext}>
            <Component {...props} />
         </EditorContext.Provider>
      );
   };
};
